import React from 'react'
import styled, { css } from 'styled-components'
import * as CSS from 'csstype'
import { compose, system, typography, color, space, layout } from 'styled-system'

import { HTMLProps } from 'react'
import { FontProps, TextDecorationProps } from '../theme/typography'
import { SystemProps } from '../theme'
import { ThemeColors } from '../theme/colors'
import { TextStyle } from './types'
import { textPropsByTextStyle } from './helpers'

export type TextProps = SystemProps &
  FontProps &
  HTMLProps<HTMLAnchorElement> &
  TextDecorationProps & {
    disabled?: boolean
    overflowWrap?: CSS.Property.OverflowWrap
    textDecorationColor?: ThemeColors
    textOverflow?: CSS.Property.TextOverflow
    textStyle?: TextStyle
    textTransform?: CSS.Property.TextTransform
    whiteSpace?: CSS.Property.WhiteSpace
  }

const TextDef = styled.span<TextProps>(
  compose(typography, space, color, layout),
  system({
    fontSize: {
      property: 'fontSize',
      scale: 'fontSizes',
    },
    lineHeight: {
      property: 'lineHeight',
      scale: 'lineHeights',
    },
    fontWeight: {
      property: 'fontWeight',
      scale: 'fontWeights',
    },
    opacity: {
      property: 'opacity',
      scale: 'opacities',
    },
    textTransform: {
      property: 'textTransform',
      scale: 'textTransforms',
    },
    textDecoration: {
      property: 'textDecoration',
    },
  })
)

export const TextBase = styled(TextDef)`
  ${props =>
    props.textDecorationColor &&
    css`
      text-decoration-color: ${props.theme.colors[props.textDecorationColor]};
    `}

  ${props =>
    props.whiteSpace &&
    css`
      white-space: ${props.whiteSpace};
    `}
  ${props =>
    props.textOverflow &&
    css`
      text-overflow: ${props.textOverflow};
    `}
    ${props =>
    props.overflowWrap &&
    css`
      overflow-wrap: ${props.overflowWrap};
    `}
`

TextBase.defaultProps = {
  fontFamily: 'primary',
  lineHeight: '100%',
  fontSize: 14,
  color: 'neutral-dark-100',
}

TextBase.displayName = 'Text'

export const Text = (props: TextProps) => {
  const textStyleProps = props.textStyle ? textPropsByTextStyle[props.textStyle] : {}
  return <TextBase {...textStyleProps} {...props} />
}

/** @deprecated use Text instead */
export const Title = styled(TextBase)(
  system({
    fontSize: {
      property: 'fontSize',
      scale: 'fontTitleSizes',
    },
    lineHeight: {
      property: 'lineHeight',
      scale: 'titleLineHeights',
    },
  })
)

Title.defaultProps = {
  fontFamily: 'primary',
  lineHeight: '150%',
  fontWeight: 600,
  fontSize: 0,
  color: 'neutral-dark-100',
  as: 'h1',
}

Title.displayName = 'Title'

export const LabelText = styled(TextBase).attrs({ as: 'label' })<{ htmlFor?: string }>``

LabelText.defaultProps = {
  color: 'neutral-dark-48',
  fontWeight: 600,
  mb: 2,
  display: 'block',
}

export const TextEllipsis = styled(Text)``

TextEllipsis.defaultProps = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  display: 'block',
  width: '100%',
}
